export default "__VITE_ASSET__1Hs5Y4Ld__"